export const getPixelsKeys = (state) => {
    return state.pixels_keys
}

export const getPixelKey = (state) => (index) => {
    return state.pixels_key[index]
}

export const getAllPixelKey = (state) => {
    return state.pixels_key
}

export const getPixelValue = (state) => (index) => {
    return state.pixels_value[index]
}

export const getAllPixelValue = (state) => {
    return state.pixels_value
}